import React, { useContext, useEffect } from 'react';
import { OnboardingContainer } from '../../common/components/OnboardingContainer';
import { AppContext } from '../../App';
import { WelcomeMobile } from './components/WelcomeMobile';
import { WelcomePc } from './components/WelcomePC';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../AppRoutes';
import { useTrack } from '@hackler/react-sdk';
import { getSavedAuth } from '../../common/utils/storage';
import { getUser } from '../../common/api/apiClient';
import { doRedirect } from '../../common/utils/utils';

export const Welcome: React.FC = () => {
  const { isMobile, redirect } = useContext(AppContext);
  const navigate = useNavigate();
  const track = useTrack();

  useEffect(() => {
    track({ key: 'view_workspaces_step0' });
    const auth = getSavedAuth();
    if (auth) {
      getUser(auth?.access_token).then(user => {
        if (user.companies.length) {
          doRedirect(redirect, auth);
        }
      });
    }
  }, []);

  const moveStep = (step: 'create' | 'invite') => {
    if (step === 'create') {
      track({ key: 'click_workspaces_create' });
    } else {
      track({ key: 'click_invitation link' });
    }

    navigate(`${step === 'create' ? appRoutes.createCompany.path() : appRoutes.invite.path()}`);
  };

  return (
    <OnboardingContainer step={'welcome'}>
      {isMobile ? <WelcomeMobile moveStep={moveStep} /> : <WelcomePc moveStep={moveStep} />}
    </OnboardingContainer>
  );
};
